import { render, staticRenderFns } from "./card-title.vue?vue&type=template&id=7474e284&scoped=true"
import script from "./card-title.vue?vue&type=script&lang=js"
export * from "./card-title.vue?vue&type=script&lang=js"
import style0 from "./card-title.vue?vue&type=style&index=0&id=7474e284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7474e284",
  null
  
)

export default component.exports